// src/constants/env.js

/**
 * Helper to read environment variables from Vite (import.meta.env).
 * Try beberapa nama kunci agar kompatibel dengan variasi prefix (VITE_APP_* atau VITE_*).
 */
const getEnv = (key) => {
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key] !== undefined) {
    return import.meta.env[key];
  }
  return undefined;
};

export const BASE_URLS = {
  FLEET_ITI_STG: getEnv('VITE_APP_BASE_URL_FLEET_ITI_STG') || ''
};

export const API_BASES = {
  FLEET_API: getEnv('VITE_APP_BASE_URL_API_FLEET_STG') || '',
  FLEET_API_GO: getEnv('VITE_APP_BASE_URL_API_GO_FLEET_STG') || '',
  ADDRESS: getEnv('VITE_APP_BASE_URL_ADDRESS_FLEET_STG') || '',
  VSS: getEnv('VITE_APP_BASE_URL_VSS_FLEET_STG') || 'https://vss-stg.fleet.iti.co.id/vss',
  HOWEN_API: getEnv('VITE_APP_BASE_URL_HOWEN_API_FLEET_STG') || 'https://howenapi-stg.fleet.iti.co.id'
};

export const VSS_CONFIG = {
  HOST: getEnv('VITE_APP_BASE_URL_VSS_FLEET_STG_IP') || 'vss-stg.fleet.iti.co.id',
  IP_URL: getEnv('VITE_APP_BASE_URL_IP_VSS_FLEET_STG') || 'https://103.169.73.227/vss'
};

export const SPACES = {
  FMS_ITI_SPACES: getEnv('VITE_APP_BASE_URL_FLEET_SPACES_STG') || ''
};

// Debug mode (boolean)
const _debugRaw = getEnv('VITE_APP_DEBUG_MODE') ?? '';
export const DEBUG_MODE = String(_debugRaw).toLowerCase() === 'true';

export const COMPANY_ID = getEnv('VITE_APP_COMPANY_ID') || '';
